import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_gc7m3wmt3x: FaireBrandEntity = {
  token: "b_gc7m3wmt3x",
  type: "brand",
  name: "Maven Home",
  avatarUrl:
    "https://cdn.faire.com/fastly/13d84fedcf9dfa5baaffa1bf8c6a6becab16a2793788f25070756df7a0c75ab6.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/259193b1f33d21316c1700b0a4da1da9d8f4c0e084a4b5698e2caf1048928436.png",
  logoUrl:
    "https://cdn.faire.com/fastly/13d84fedcf9dfa5baaffa1bf8c6a6becab16a2793788f25070756df7a0c75ab6.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/259193b1f33d21316c1700b0a4da1da9d8f4c0e084a4b5698e2caf1048928436.png",
  location: "Highland Park, IL, USA",
  minimumOrderDollars: 250,
  rating: 5,
  reviewCount: 36,
  isTopShop: true,
  isInsider: true,
  description:
    "About Maven Home\nMaven Home was founded by Dawn and Sherry, two longtime friends and design lovers .  Their shared passion for travel, culture, and craftsmanship led them to Paris, where a visit to the legendary Maison & Objet show sparked an idea to bring a sophisticated, globally inspired aesthetic to the U.S. market in a way that felt fresh, modern, and attainable.\nDawn, originally from South Africa, and Sherry, with Mexican and European roots, draw from their diverse backgrounds and world travels to create collections that blend color, form, and joy. Every piece reflects their belief that great design should feel both elevated and effortless — something that delights customers and adds character to any space.\nTheir years of hands-on retail experience give Maven Home a rare perspective. They know what sells, what connects, and what makes people smile. That insight shapes everything  from the way they design, to how they partner with retailers.\nMaven Home is more than a brand; it’s a collaboration between two women who believe that design should be personal, inspired, and full of life.\nMaven Home  globally inspired design, made for modern living.\n\n",
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:55:10.077Z",
    importedBy: "entity-db-cli",
  },
};
